export default "__VITE_ASSET__8076dab8__"